import type { BookingStatus } from '@duvamarine/shared';

export const BOOKING_STATUS_TONE: Record<
  BookingStatus,
  'gold' | 'info' | 'success' | 'neutral' | 'warning' | 'danger'
> = {
  DRAFT: 'neutral',
  PENDING_PAYMENT: 'warning',
  AWAITING_CONFIRMATION: 'info',
  CONFIRMED: 'success',
  IN_PROGRESS: 'gold',
  COMPLETED: 'neutral',
  CANCELLED: 'danger',
  REFUNDED: 'neutral',
  NO_SHOW: 'neutral',
};
